var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRewards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.89863 8.3181L9.10533 17.6581L7.15698 12.4888L8.21955 12.058L10.9992 19.4312L15.1897 8.31824H6.80962L7.35875 9.77546L6.29618 10.2062L5.58452 8.31824L1.89863 8.3181ZM13.5806 3.18577L15.8754 6.49768L17.1237 3.18577H13.5797H13.5806ZM14.9129 7.13231L12.1778 3.18577H9.89459L7.15954 7.13231H14.9129ZM6.14879 6.56814L8.49273 3.18579H4.87281L6.1479 6.56814H6.14879ZM12.8921 17.6581L20.0988 8.31812H16.4138L12.8921 17.6581ZM5.13615 7.13233L3.95659 4.00304L1.81714 7.13233H5.13692H5.13615ZM18.0148 4.07252L16.8611 7.13233H20.1649L18.0157 4.07252H18.0148ZM10.5544 21.4249L0 7.74562L3.92806 2H17.9666L22 7.74183L10.9983 22L10.5544 21.4249Z",
    fill: "#BF1E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRewards);
export default __webpack_public_path__ + "static/media/iconRewards.5160155dc9c3141420e5b45e48e87be9.svg";
export { ForwardRef as ReactComponent };